import React, { createContext, useCallback, useContext, useState } from "react";
import toast from 'react-hot-toast';
import {api} from '../services/api';


interface User {
    assinante?: string
    email: string
    iduser: string
    nome: string
    thumb_user?: string
    vitalicio?: string
    jwt: string
    conjuge?: string
}

interface AuthState{
    jwt: string;
    user: User;
}
interface SignInCredencials{
    email: string;
    pass: string;
}
interface AuthContextState{
    user: User;
    jwt: string;
    signIn(credencials : SignInCredencials): Promise<void>;
    signOut() : void;
    updateUser(user: User) : void
}

const AuthContext = createContext<AuthContextState>({} as AuthContextState);

export const AuthProvider: React.FC<{children: React.ReactNode}> = ({children}) => {

    // verificando se esta logado
    const [data, setData] = useState<AuthState>(() => {
        const jwt = localStorage.getItem('@mob:jwt');
        const user = localStorage.getItem('@mob:user');
        if(jwt && user){
            return { jwt, user: JSON.parse(user)}
        }
        return {} as AuthState;
    });

    // logando
    const signIn = useCallback(async({email, pass}: SignInCredencials) => {
        try {
            toast.dismiss();
            const resp = await api.post('login.php', {
                email,
                pass,
            });
            // console.log(resp.data);
            const { jwt, user } = resp.data;
            
            localStorage.setItem('@mob:jwt', jwt );
            localStorage.setItem('@mob:user', JSON.stringify(user));
            setData({ jwt, user });
            toast.success('SUCESSO');

        } catch (err: any) {
            let error = err.toString();
            if(error.search("Network Error") !== -1){
                toast.dismiss();
                toast.error('ESTAMOS COM PROBLEMAS NO BANCO DE DADOS, POR FAVOR TENTE MAIS TARDE.');                
            } else {
                toast.dismiss();
                toast.error('ERRO DE LOGIN, VERIFIQUE SEUS DADOS');
            }
        }
    }, []);

    // deslogando
    const signOut = useCallback(() => {
        localStorage.removeItem('@mob:jwt');
        localStorage.removeItem('@mob:user');

        setData({} as AuthState);
    }, []);


    const updateUser = useCallback((user: User) => {
        setData({
            jwt: data.jwt,
            user
        })    
        localStorage.setItem('@mob:user', JSON.stringify(user));    
    }, [setData, data.jwt]);

    return(
        <AuthContext.Provider value={{user : data.user, jwt : data.jwt, signIn, signOut, updateUser}}>
            {children} 
        </AuthContext.Provider>
    )
}

export function useAuth(): AuthContextState{
    const context = useContext(AuthContext);
    if(!context){
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}

